<template>
  <div class="taxes-v2">
    <template v-if="!showVatEditor && !showRuleEditor">
      <div id="outer-container">
        <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
          <div class="card-content">
            <div class="clearfix row pad-lf-10 pad-rg-10">
              <a class="btn btn-fill btn-primary" :class="{ active: activeTab === 'vat' }" @click="openTaxTab('vat')">TVA</a>
              <a class="btn btn-fill btn-primary" :class="{ active: activeTab === 'rules' }" @click="openTaxTab('rules')">ALTE TAXE</a>
            </div>
          </div>
        </div>
      </div>

      <div class="card tax-card tax-engine-card">
        <div class="card-content tax-engine-content">
          <div>
            <h4 class="tax-card-title">Motor taxe V2</h4>
            <p class="help-block tax-help">Versiunea se salvează pe fiecare comandă. Comenzile vechi continuă cu motorul vechi.</p>
          </div>
          <label class="tax-switch">
            <input type="checkbox" :checked="taxesVersion === 2" @change="setTaxesVersion($event.target.checked ? 2 : 1)">
            <span class="tax-switch-track"><span class="tax-switch-thumb"></span></span>
            <span>{{ taxesVersion === 2 ? 'Activ' : 'Inactiv' }}</span>
          </label>
        </div>
      </div>
    </template>

    <transition name="tax-page" mode="out-in">
      <div v-if="activeTab === 'vat'" :key="showVatEditor ? 'vat-editor' : 'vat-list'">
        <div v-if="!showVatEditor" class="card tax-card">
          <div class="card-content">
            <div class="tax-list-header">
              <div>
                <h3 class="tax-card-title">Cote TVA</h3>
                <p class="help-block tax-help">Cotele inactive nu mai apar la selectare, dar rămân valabile acolo unde sunt deja folosite.</p>
              </div>
              <button class="btn add" title="Adaugă TVA" @click.prevent="openCreateVat"><img src="/static/img/icons/add.png">Adaugă TVA</button>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead><tr><th>Cotă</th><th>Stare</th><th>Utilizare</th><th class="text-right">Acțiuni</th></tr></thead>
                <tbody>
                  <tr v-for="vat in vatRates" :key="vat.id">
                    <td class="tax-rate-value">{{ formatRate(vat.rate) }}%</td>
                    <td>
                      <label class="tax-switch tax-switch-small"><input type="checkbox" :checked="vat.is_active" @change="toggleVat(vat, $event.target.checked)"><span class="tax-switch-track"><span class="tax-switch-thumb"></span></span><span>{{ vat.is_active ? 'Activ' : 'Inactiv' }}</span></label>
                    </td>
                    <td>{{ vat.is_used ? usageLabel(vat.usage) : 'Nefolosit' }}</td>
                    <td class="text-right tax-actions-cell">
                      <a class="btn delete mar-rt-10" :class="{ disabled: vat.is_used }" :title="vat.is_used ? 'TVA-ul folosit nu poate fi șters' : 'Șterge'" @click.prevent="deleteVat(vat)"><img src="/static/img/icons/icon-close.png">Șterge</a>
                      <div class="edit tax-edit-action" @click="openEditVat(vat)"><i class="fa fa-pencil"></i>Editează</div>
                    </td>
                  </tr>
                  <tr v-if="!vatRates.length"><td colspan="4" class="tax-empty">Nu există cote TVA configurate.</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-else class="tax-detail-view">
          <div class="settings-top-bar sticky-header">
            <div class="top-bar">
              <p><a class="btn btn-orange btn-icon back" title="Înapoi" @click.prevent="closeVatEditor"><i class="ti-arrow-left"></i> Înapoi</a></p>
              <p class="d-inline-flex"><button type="button" class="btn btn-success btn-icon mar-rt-10 save" :disabled="saving" @click="saveVat"><img src="/static/img/icons/save.png">Salvează</button></p>
            </div>
          </div>

          <div class="card tax-card">
            <div class="card-content">
              <div class="tax-card-header"><div><h3 class="tax-card-title">{{ vatForm.id ? 'TVA ' + formatRate(vatForm.rate) + '%' : 'Adaugă TVA' }}</h3><p class="help-block tax-help">{{ vatForm.id ? 'Configurează starea și aplicarea acestei cote TVA. Valoarea nu mai poate fi schimbată după salvare.' : 'Salvează cota, apoi o poți aplica pe produse și liste de preț.' }}</p></div></div>
              <div class="tax-form-grid tax-vat-details-grid">
                <div class="form-group">
                  <label>Cotă TVA</label>
                  <div class="tax-rate-input"><input v-model.number="vatForm.rate" type="number" min="0" max="100" step="0.01" class="form-control" :disabled="!!vatForm.id" placeholder="Cotă TVA"><span>%</span></div>
                </div>
                <div class="form-group tax-active-field">
                  <label>Stare</label>
                  <label class="tax-switch"><input v-model="vatForm.is_active" type="checkbox"><span class="tax-switch-track"><span class="tax-switch-thumb"></span></span><span>{{ vatForm.is_active ? 'Activ' : 'Inactiv' }}</span></label>
                </div>
              </div>
            </div>
          </div>

          <template v-if="vatForm.id">
            <div class="card tax-card">
              <div class="card-content">
                <div class="tax-card-header"><div><h3 class="tax-card-title">Aplică TVA pe produsele din categorii</h3><p class="help-block tax-help">Cota {{ formatRate(vatForm.rate) }}% va fi salvată pe toate produsele din categoriile alese.</p></div></div>
                <div class="tax-form-grid tax-category-vat-grid">
                  <div class="form-group"><label>Categorii</label><el-select v-model="productVatTool.category_ids" multiple filterable collapse-tags clearable class="tax-select" placeholder="Selectează"><el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id"></el-option></el-select></div>
                  <div class="tax-selected-entity"><span>TVA aplicat</span><strong>{{ formatRate(vatForm.rate) }}%</strong></div>
                  <div class="tax-form-action"><button class="btn tax-primary-action" @click="applyProductVat">Aplică pe produse</button></div>
                </div>
              </div>
            </div>

            <div class="card tax-card">
              <div class="card-content">
                <div class="tax-card-header"><div><h3 class="tax-card-title">Aplică TVA în lista de preț</h3><p class="help-block tax-help">Se actualizează numai TVA-ul și starea poziției. Prețul și POS ID rămân neschimbate.</p></div></div>
                <div class="tax-form-grid tax-profile-grid">
                  <div class="form-group"><label>Listă de preț / locații</label><select v-model="profileVatTool.price_profile_id" class="form-control"><option disabled value="">Selectează</option><option v-for="p in priceProfiles" :key="p.id" :value="p.id">{{ profileLabel(p) }}</option></select></div>
                  <div class="form-group tax-grid-wide"><label>Categorii</label><el-select v-model="profileVatTool.category_ids" multiple filterable collapse-tags clearable class="tax-select" placeholder="Selectează"><el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id"></el-option></el-select></div>
                  <div class="form-group"><label>Surse</label><el-select v-model="profileVatTool.source_ids" multiple filterable collapse-tags clearable class="tax-select" placeholder="Selectează"><el-option v-for="s in sources" :key="s.id" :label="s.name" :value="s.id"></el-option></el-select></div>
                  <div class="form-group"><label>Metode</label><el-select v-model="profileVatTool.method_ids" multiple filterable collapse-tags clearable class="tax-select" placeholder="Selectează"><el-option v-for="m in methods" :key="m.id" :label="m.name" :value="m.id"></el-option></el-select></div>
                </div>
                <div class="tax-card-footer"><span class="tax-field-hint">Locațiile sunt cele configurate pe lista de preț.</span><button class="btn tax-primary-action" @click="applyProfileVat">Aplică TVA {{ formatRate(vatForm.rate) }}%</button></div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div v-else :key="showRuleEditor ? 'rule-editor' : 'rule-list'">
        <div v-if="!showRuleEditor" class="card tax-card">
          <div class="card-content">
            <div class="tax-list-header">
              <div><h3 class="tax-card-title">Taxe configurate</h3><p class="help-block tax-help">Taxele pot fi activate, dezactivate sau editate direct din listă.</p></div>
              <button class="btn add" title="Adaugă taxă" @click.prevent="openCreateRule()"><img src="/static/img/icons/add.png">Adaugă taxă</button>
            </div>
            <div class="table-responsive">
              <table class="table tax-rules-table">
                <thead><tr><th>Nume</th><th>Tip</th><th>Calcul</th><th>TVA</th><th>POS ID</th><th>Locații</th><th>Stare</th><th class="text-right">Acțiuni</th></tr></thead>
                <tbody>
                  <tr v-for="rule in taxRules" :key="rule.id">
                    <td><strong>{{ rule.name }}</strong></td><td>{{ taxTypeLabel(rule.applies_to) }}</td><td>{{ rule.calculation_type === 'fixed' ? rule.value + ' fix' : rule.value + '%' }}</td><td>{{ rule.vat_rate ? formatRate(rule.vat_rate.rate) + '%' : '-' }}</td><td>{{ rule.pos_id || '-' }}</td><td :title="scopeSummary(rule)">{{ relationNames(rule.location_ids, locations, 'Toate') }}</td>
                    <td><label class="tax-switch tax-switch-small"><input type="checkbox" :checked="rule.is_active" @change="toggleRule(rule, $event.target.checked)"><span class="tax-switch-track"><span class="tax-switch-thumb"></span></span><span>{{ rule.is_active ? 'Activ' : 'Inactiv' }}</span></label></td>
                    <td class="text-right tax-actions-cell"><a class="btn delete mar-rt-10" title="Șterge" @click.prevent="deleteRule(rule)"><img src="/static/img/icons/icon-close.png">Șterge</a><div class="edit tax-edit-action" @click="openEditRule(rule)"><i class="fa fa-pencil"></i>Editează</div></td>
                  </tr>
                  <tr v-if="!taxRules.length"><td colspan="8" class="tax-empty">Nu există alte taxe configurate.</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-else class="tax-detail-view">
          <div class="settings-top-bar sticky-header">
            <div class="top-bar">
              <p><a class="btn btn-orange btn-icon back" title="Înapoi" @click.prevent="closeRuleEditor"><i class="ti-arrow-left"></i> Înapoi</a></p>
              <p class="d-inline-flex"><button type="button" class="btn btn-success btn-icon mar-rt-10 save" :disabled="saving || loadingRule || applyingCategoryTaxes" @click="saveRule"><img src="/static/img/icons/save.png">Salvează taxa</button></p>
            </div>
          </div>

          <div v-if="loadingRule" class="card tax-card"><div class="card-content tax-page-loading"><div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg></div></div></div>
          <template v-else>
            <div class="card tax-card">
              <div class="card-content">
                <div class="tax-card-header"><div><h3 class="tax-card-title">{{ ruleForm.id ? ruleForm.name : 'Adaugă taxă' }}</h3><p class="help-block tax-help">Definește tipul, calculul și TVA-ul liniei separate care va apărea pe bon.</p></div></div>
                <div class="tax-form-grid tax-rule-main-grid">
                  <div class="form-group tax-grid-wide"><label>Nume</label><input v-model="ruleForm.name" class="form-control"></div>
                  <div class="form-group"><label>Taxă pentru</label><select v-model="ruleForm.applies_to" class="form-control" @change="handleRuleTypeChange"><option value="order">Comandă</option><option value="item">Produs/opțiune</option><option value="delivery">Livrare</option></select></div>
                  <div class="form-group"><label>Calcul</label><select v-model="ruleForm.calculation_type" class="form-control" :disabled="ruleForm.applies_to === 'delivery'"><option value="fixed">Fixă</option><option value="percentage">Procent</option></select></div>
                  <div class="form-group"><label>{{ ruleForm.applies_to === 'delivery' ? 'Cost livrare (lei)' : 'Valoare' }}</label><input v-model.number="ruleForm.value" type="number" min="0" step="0.000001" class="form-control"></div>
                  <div class="form-group"><label>TVA obligatoriu</label><select v-model="ruleForm.vat_rate_id" class="form-control"><option disabled value="">Selectează</option><option v-for="v in selectableVatRates(ruleForm.vat_rate_id)" :key="v.id" :value="v.id" :disabled="!v.is_active">{{ formatRate(v.rate) }}%{{ v.is_active ? '' : ' (inactiv)' }}</option></select></div>
                  <div class="form-group"><label>POS ID</label><input v-model.trim="ruleForm.pos_id" type="text" class="form-control" placeholder="Opțional"></div>
                  <div class="form-group tax-active-field">
                    <label>Stare</label>
                    <label class="tax-switch tax-status-switch">
                      <input v-model="ruleForm.is_active" type="checkbox" aria-label="Taxă activă">
                      <span class="tax-switch-track"><span class="tax-switch-thumb"></span></span>
                      <span>{{ ruleForm.is_active ? 'Activă' : 'Inactivă' }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="card tax-card">
              <div class="card-content">
                <div class="tax-card-header"><div><h3 class="tax-card-title">Aplicabilitate</h3><p class="help-block tax-help">Lasă un câmp gol dacă taxa se aplică tuturor valorilor din criteriul respectiv.</p></div></div>
                <div class="tax-form-grid tax-scope-grid">
                  <div class="form-group"><label>Locații</label><el-select v-model="ruleForm.location_ids" multiple filterable collapse-tags clearable class="tax-select" placeholder="Toate locațiile"><el-option v-for="l in locations" :key="l.id" :label="l.name" :value="l.id"></el-option></el-select></div>
                  <div class="form-group"><label>Surse</label><el-select v-model="ruleForm.source_ids" multiple filterable collapse-tags clearable class="tax-select" placeholder="Toate sursele"><el-option v-for="s in sources" :key="s.id" :label="s.name" :value="s.id"></el-option></el-select></div>
                  <div v-if="ruleForm.applies_to !== 'delivery'" class="form-group"><label>Metode</label><el-select v-model="ruleForm.method_ids" multiple filterable collapse-tags clearable class="tax-select" placeholder="Toate metodele"><el-option v-for="m in methods" :key="m.id" :label="m.name" :value="m.id"></el-option></el-select></div>
                  <div class="form-group"><label>Zone</label><el-select v-model="ruleForm.delivery_range_ids" multiple filterable collapse-tags clearable class="tax-select" placeholder="Toate zonele"><el-option v-for="range in deliveryRanges" :key="range.id" :label="deliveryRangeLabel(range)" :value="range.id"></el-option></el-select></div>
                </div>
              </div>
            </div>

            <div v-if="ruleForm.applies_to === 'delivery'" class="card tax-card">
              <div class="card-content">
                <div class="tax-card-header">
                  <div><h3 class="tax-card-title">Extra Cost Range</h3><p class="help-block tax-help">Intervalele suprascriu costul standard și POS ID-ul acestei taxe în funcție de distanță și valoarea comenzii.</p></div>
                  <button type="button" class="btn add" @click.prevent="addDeliveryCostRange"><img src="/static/img/icons/add.png">Adaugă interval</button>
                </div>
                <div class="tax-delivery-warning"><i class="fa fa-exclamation-triangle"></i><strong>Aceste intervale se aplică doar dacă locația are cheia Google Maps configurată.</strong> Dacă cheia lipsește sau distanța nu poate fi calculată, se aplică prețul standard al taxei.</div>
                <div v-if="!ruleForm.delivery_cost_ranges.length" class="tax-empty tax-range-empty">Nu există intervale suplimentare. Se va folosi costul standard.</div>
                <div v-for="(range, index) in ruleForm.delivery_cost_ranges" :key="range.id || 'new-' + index" class="tax-delivery-range">
                  <div class="tax-range-heading"><strong>Interval {{ index + 1 }}</strong><button type="button" class="btn delete" @click.prevent="removeDeliveryCostRange(index)"><img src="/static/img/icons/icon-close.png">Șterge</button></div>
                  <div class="tax-form-grid tax-delivery-range-grid">
                    <div class="form-group"><label>Distanță până la (km)</label><input v-model.number="range.distance_in_km" type="number" min="0" step="0.01" class="form-control"></div>
                    <div class="form-group"><label>Cost (lei)</label><input v-model.number="range.shipping_cost" type="number" min="0" step="0.01" class="form-control"></div>
                    <div class="form-group"><label>POS ID</label><input v-model.trim="range.pos_id" type="text" class="form-control" placeholder="Moștenește POS ID standard"></div>
                    <div class="form-group"><label>Comandă minimă (lei)</label><input v-model.number="range.min_order_value" type="number" min="0" step="0.01" class="form-control"></div>
                    <div class="form-group"><label>Timp extra (minute)</label><input v-model.number="range.extra_delivery_time" type="number" min="0" step="1" class="form-control"></div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="ruleForm.applies_to === 'item'" class="card tax-card tax-assignment-tool">
              <div class="card-content">
                <div class="tax-card-header">
                  <div>
                    <span class="tax-tool-badge"><i class="fa fa-calculator" aria-hidden="true"></i> Instrument de aplicare</span>
                    <h3 class="tax-card-title">Aplică taxa pe categorii</h3>
                    <p class="help-block tax-help">Adaugă taxa „{{ ruleForm.name }}” pe produsele existente în categoriile alese.</p>
                  </div>
                </div>
                <div class="tax-tool-explanation">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                  <span>Confirmă selecția cu <strong>„Aplică taxa”</strong>. Butonul „Salvează taxa” de sus salvează doar configurarea taxei.</span>
                </div>
                <p v-if="!ruleForm.id" class="tax-tool-pending">Salvează mai întâi taxa, apoi folosește acest instrument pentru a o atribui produselor.</p>
                <div class="tax-form-grid tax-rule-category-grid">
                  <div class="form-group">
                    <label>1. Alege categoriile</label>
                    <el-select v-model="taxCategoryTool.category_ids" :disabled="!ruleForm.id || saving || applyingCategoryTaxes" multiple filterable collapse-tags clearable class="tax-select" placeholder="Selectează categoriile" @change="categoryTaxResult = ''"><el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id"></el-option></el-select>
                    <span class="tax-field-hint">Taxele deja atribuite produselor se păstrează.</span>
                  </div>
                  <div class="form-group tax-option-choice">
                    <label>2. Include opțiuni, dacă este cazul</label>
                    <label class="tax-checkbox tax-options-checkbox">
                      <input v-model="taxCategoryTool.include_option_values" :disabled="!ruleForm.id || saving || applyingCategoryTaxes" type="checkbox" aria-describedby="tax-options-help" @change="categoryTaxResult = ''">
                      <span>Aplică taxa și pe opțiuni</span>
                    </label>
                    <p id="tax-options-help" class="tax-option-help">De exemplu, „Extra brânză”. Aceeași valoare de opțiune primește taxa la toate produsele care o folosesc, conform aplicabilității taxei.</p>
                    <p v-if="taxCategoryTool.include_option_values" class="tax-option-note"><i class="fa fa-info-circle" aria-hidden="true"></i> Taxa se calculează separat pentru produs și pentru fiecare opțiune taxată aleasă.</p>
                  </div>
                </div>
                <div class="tax-card-footer tax-tool-footer">
                  <div aria-live="polite">
                    <p v-if="taxCategoryTool.category_ids.length" class="tax-tool-pending"><strong>{{ taxCategoryTool.category_ids.length }} categorii selectate — încă neaplicate.</strong><br>Apasă „Aplică taxa” pentru a salva atribuirile.</p>
                    <p v-else class="tax-help">Atribuirile se salvează imediat prin „Aplică taxa”.</p>
                    <p v-if="taxesVersion !== 2" class="tax-help">Atribuirile se păstrează pentru migrare. Taxa se va aplica în comenzi după activarea Taxe V2.</p>
                  </div>
                  <button type="button" class="btn tax-primary-action tax-apply-action" :disabled="!ruleForm.id || !taxCategoryTool.category_ids.length || saving || applyingCategoryTaxes" @click="applyCategoryTaxes"><i :class="applyingCategoryTaxes ? 'fa fa-spinner fa-spin' : 'fa fa-check'" aria-hidden="true"></i> {{ applyingCategoryTaxes ? 'Se aplică…' : 'Aplică taxa' }}</button>
                </div>
                <p v-if="categoryTaxResult" class="tax-tool-result" role="status"><i class="fa fa-check-circle" aria-hidden="true"></i> {{ categoryTaxResult }}</p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import {Select, Option} from 'element-ui'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'

Vue.use(Select)
Vue.use(Option)

const emptyVat = () => ({ id: null, rate: null, is_active: true, is_used: false, usage: {} })
const emptyRule = () => ({ id: null, name: '', applies_to: 'order', calculation_type: 'fixed', value: 0, pos_id: '', vat_rate_id: '', is_active: true, location_ids: [], source_ids: [], method_ids: [], delivery_range_ids: [], product_ids: [], company_option_value_ids: [], delivery_cost_ranges: [] })

export default {
  data () {
    return {
      activeTab: 'vat',
      saving: false,
      loadingRule: false,
      applyingCategoryTaxes: false,
      categoryTaxResult: '',
      showVatEditor: false,
      showRuleEditor: false,
      taxesVersion: 1,
      vatRates: [],
      taxRules: [],
      categories: [],
      priceProfiles: [],
      locations: [],
      deliveryRanges: [],
      sources: [{id: 1, name: 'Website'}, {id: 2, name: 'QR'}, {id: 3, name: 'Kiosk'}, {id: 4, name: 'POS'}, {id: 5, name: 'App'}, {id: 6, name: 'Glovo'}, {id: 7, name: 'Bolt'}, {id: 8, name: 'Wolt'}],
      methods: [{id: 1, name: 'EatIn'}, {id: 2, name: 'ToGo'}, {id: 3, name: 'Delivery'}],
      productVatTool: {category_ids: [], vat_rate_id: ''},
      profileVatTool: {price_profile_id: '', category_ids: [], vat_rate_id: '', source_ids: [], method_ids: []},
      taxCategoryTool: {category_ids: [], tax_rule_ids: [], include_option_values: false},
      vatForm: emptyVat(),
      ruleForm: emptyRule()
    }
  },
  computed: {
    companyId () { return this.$session.get('selectedCompany') },
    token () { return this.$session.get('token') }
  },
  created () {
    const companyData = this.$session.get('selectedCompanyData') || {}
    this.taxesVersion = Number(companyData.taxes_version) === 2 ? 2 : 1
    this.locations = (companyData.locations_details || []).map(l => ({id: l.true_id || l.id, token: l.token, name: l.name}))
    this.loadAll()
    this.openRuleFromRoute()
  },
  methods: {
    requestData (extra) { return Object.assign({token: this.token, company_id: this.companyId}, extra || {}) },
    openTaxTab (tab) {
      if (this.applyingCategoryTaxes) return
      this.activeTab = tab
      this.showVatEditor = false
      this.showRuleEditor = false
      this.vatForm = emptyVat()
      this.ruleForm = emptyRule()
    },
    loadAll () { this.loadVat(); this.loadRules(); this.loadCategories(); this.loadProfiles(); this.loadDeliveryRanges() },
    loadVat () { this.apiRequest('/taxes-v2/vat-rates', 'GET', this.requestData(), r => { if (r.status) this.vatRates = r.data || [] }) },
    loadRules () { this.apiRequest('/taxes-v2/rules', 'GET', this.requestData(), r => { if (r.status) { this.taxRules = r.data || []; this.mergeDeliveryRanges() } }) },
    loadCategories () { this.apiRequest('/category', 'GET', this.requestData(), r => { if (r.status) this.categories = r.data || [] }) },
    loadProfiles () { this.apiRequest('/price-profiles', 'GET', this.requestData({perPage: 500}), r => { if (r.status) this.priceProfiles = r.data || [] }) },
    loadDeliveryRanges () { this.apiRequest('/price-profiles/scope-options', 'GET', this.requestData({location_ids: this.locations.map(l => l.id)}), r => { if (r.status) this.mergeDeliveryRanges((r.data && r.data.delivery_ranges) || []) }) },
    formatRate (v) { return Number(v).toLocaleString('ro-RO', {maximumFractionDigits: 2}) },
    usageLabel (usage) { return Object.keys(usage || {}).map(k => `${k}: ${usage[k]}`).join(', ') },
    relationNames (ids, options, emptyLabel) { if (!ids || !ids.length) return emptyLabel; return ids.map(id => (options.find(o => String(o.id) === String(id)) || {name: '#' + id}).name).join(', ') },
    scopeSummary (rule) {
      return [
        'Locații: ' + this.relationNames(rule.location_ids, this.locations, 'toate'),
        'Surse: ' + this.relationNames(rule.source_ids, this.sources, 'toate'),
        'Metode: ' + this.relationNames(rule.method_ids, this.methods, 'toate'),
        'Zone: ' + this.relationNames(rule.delivery_range_ids, this.deliveryRanges, 'toate')
      ].join('; ')
    },
    responseMessage (response, fallback) {
      const errorData = response && response.error && response.error.response && response.error.response.data
      if (response && response.message) return response.message
      if (errorData && errorData.message) return errorData.message
      if (errorData && errorData.errors) {
        const first = Object.keys(errorData.errors)[0]
        const value = first ? errorData.errors[first] : null
        if (Array.isArray(value)) return value[0]
        if (value) return value
      }
      return fallback
    },
    profileLabel (profile) { const names = (profile.location_details || []).map(l => l.name).join(', '); return names ? `${profile.name} — ${names}` : profile.name },
    deliveryRangeLabel (range) { const location = this.locations.find(l => String(l.token) === String(range.location_id)); return location ? `${range.name} — ${location.name}` : range.name },
    mergeDeliveryRanges (ranges) {
      const merged = {}
      ;(this.deliveryRanges || []).concat(ranges || []).forEach(range => { merged[String(range.id)] = range })
      ;(this.taxRules || []).forEach(rule => {
        ;(rule.delivery_ranges || []).forEach(range => { merged[String(range.id)] = range })
      })
      ;((this.ruleForm && this.ruleForm.delivery_ranges) || []).forEach(range => { merged[String(range.id)] = range })
      this.deliveryRanges = Object.keys(merged).map(id => merged[id]).sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), 'ro'))
    },
    taxTypeLabel (type) { return type === 'order' ? 'Comandă' : (type === 'delivery' ? 'Livrare' : 'Produs/opțiune') },
    selectableVatRates (selected) { return this.vatRates.filter(v => v.is_active || String(v.id) === String(selected)) },
    notify (text, type) { swal({text, type: type || 'success', showConfirmButton: false, timer: 2200}) },
    setTaxesVersion (version) {
      this.apiRequest('/taxes-v2/version', 'PUT', this.requestData({taxes_version: version}), r => {
        if (!r.status) { this.notify(this.responseMessage(r, 'Versiunea taxelor nu a putut fi actualizată.'), 'error'); return }
        this.taxesVersion = version
        const companyData = this.$session.get('selectedCompanyData') || {}
        companyData.taxes_version = version
        this.$session.set('selectedCompanyData', companyData)
        this.notify(version === 2 ? 'Motorul de taxe V2 este activ.' : 'Motorul vechi de taxe este activ.')
      })
    },
    resetVatTools (vatRateId) {
      this.productVatTool = {category_ids: [], vat_rate_id: vatRateId || ''}
      this.profileVatTool = {price_profile_id: '', category_ids: [], vat_rate_id: vatRateId || '', source_ids: [], method_ids: []}
    },
    openCreateVat () {
      this.vatForm = emptyVat()
      this.resetVatTools(null)
      this.showVatEditor = true
    },
    openEditVat (vat) {
      this.vatForm = Object.assign(emptyVat(), JSON.parse(JSON.stringify(vat)))
      this.resetVatTools(vat.id)
      this.showVatEditor = true
    },
    closeVatEditor () {
      this.showVatEditor = false
      this.vatForm = emptyVat()
      this.resetVatTools(null)
    },
    saveVat () {
      if (this.vatForm.rate === null || this.vatForm.rate === '') { this.notify('Completează cota TVA.', 'error'); return }
      this.saving = true
      const isEdit = !!this.vatForm.id
      const url = '/taxes-v2/vat-rates' + (isEdit ? '/' + this.vatForm.id : '')
      const payload = isEdit ? {is_active: this.vatForm.is_active ? 1 : 0} : {rate: this.vatForm.rate, is_active: this.vatForm.is_active ? 1 : 0}
      this.apiRequest(url, isEdit ? 'PUT' : 'POST', this.requestData(payload), r => {
        this.saving = false
        if (!r.status) { this.notify(this.responseMessage(r, 'Cota TVA nu a putut fi salvată.'), 'error'); return }
        this.vatForm = Object.assign(emptyVat(), this.vatForm, r.data || {})
        this.resetVatTools(this.vatForm.id)
        this.loadVat()
        this.notify(isEdit ? 'Cota TVA a fost actualizată.' : 'Cota TVA a fost adăugată.')
      })
    },
    toggleVat (vat, active) { this.apiRequest('/taxes-v2/vat-rates/' + vat.id, 'PUT', this.requestData({is_active: active ? 1 : 0}), r => { if (r.status) this.loadVat(); else this.notify(this.responseMessage(r, 'TVA-ul nu a putut fi actualizat.'), 'error') }) },
    deleteVat (vat) { if (vat.is_used) return; this.apiRequest('/taxes-v2/vat-rates/' + vat.id, 'DELETE', this.requestData(), r => { if (r.status) { this.loadVat(); this.notify('Cota TVA a fost ștearsă.') } else this.notify(this.responseMessage(r, 'TVA-ul nu poate fi șters.'), 'error') }) },
    applyProductVat () { this.postTool('/taxes-v2/tools/products/vat', this.productVatTool, 'TVA-ul a fost aplicat produselor.') },
    applyProfileVat () { this.postTool('/taxes-v2/tools/price-profiles/vat', this.profileVatTool, 'TVA-ul a fost aplicat listei de preț.') },
    applyCategoryTaxes () {
      if (!this.ruleForm.id || !this.taxCategoryTool.category_ids.length || this.saving || this.applyingCategoryTaxes) return
      const ruleId = this.ruleForm.id
      const payload = Object.assign({}, this.taxCategoryTool, {tax_rule_ids: [ruleId], category_ids: this.taxCategoryTool.category_ids.slice()})
      this.applyingCategoryTaxes = true
      this.categoryTaxResult = ''
      this.apiRequest('/taxes-v2/tools/categories/taxes', 'POST', this.requestData(payload), r => {
        this.applyingCategoryTaxes = false
        if (!r.status) { this.notify(this.responseMessage(r, 'Atribuirile nu au putut fi salvate. Încearcă din nou.'), 'error'); return }
        const data = r.data || {}
        if (this.ruleForm.id === ruleId) {
          // Keep a later Save from replacing the assignments with the old form values.
          ;['product_ids', 'company_option_value_ids'].forEach(field => {
            this.ruleForm[field] = Array.from(new Set((this.ruleForm[field] || []).concat(data[field] || []).map(Number)))
          })
          this.taxCategoryTool.category_ids = []
          this.categoryTaxResult = `Atribuiri salvate: ${data.products || 0} produse și ${data.option_values || 0} valori de opțiuni. Nu mai trebuie să apeși „Salvează taxa” pentru aceste atribuiri.`
        }
        this.loadRules()
      })
    },
    postTool (url, payload, message) { this.apiRequest(url, 'POST', this.requestData(payload), r => { if (r.status) this.notify(message); else this.notify(this.responseMessage(r, 'Operația nu a putut fi finalizată.'), 'error') }) },
    saveRule () {
      if (this.saving || this.loadingRule || this.applyingCategoryTaxes) return
      const payload = Object.assign({}, this.ruleForm)
      if (payload.applies_to === 'delivery') {
        payload.calculation_type = 'fixed'
        payload.method_ids = [3]
      }
      const url = '/taxes-v2/rules' + (payload.id ? '/' + payload.id : '')
      this.saving = true
      this.apiRequest(url, payload.id ? 'PUT' : 'POST', this.requestData(payload), r => {
        this.saving = false
        if (!r.status) { this.notify(this.responseMessage(r, 'Taxa nu a putut fi salvată.'), 'error'); return }
        this.ruleForm = Object.assign(emptyRule(), JSON.parse(JSON.stringify(r.data || payload)))
        this.mergeDeliveryRanges(this.ruleForm.delivery_ranges || [])
        this.taxCategoryTool.tax_rule_ids = this.ruleForm.id ? [this.ruleForm.id] : []
        this.loadRules()
        this.loadVat()
        this.notify(this.ruleForm.applies_to === 'item' && this.taxCategoryTool.category_ids.length
          ? 'Taxa a fost salvată. Categoriile selectate încă nu au fost aplicate: apasă „Aplică taxa” în instrumentul de mai jos.'
          : 'Taxa a fost salvată.', this.ruleForm.applies_to === 'item' && this.taxCategoryTool.category_ids.length ? 'info' : 'success')
      })
    },
    openCreateRule (preset) {
      this.categoryTaxResult = ''
      this.ruleForm = emptyRule()
      if (preset) this.ruleForm = Object.assign(this.ruleForm, preset)
      this.handleRuleTypeChange()
      this.taxCategoryTool = {category_ids: [], tax_rule_ids: [], include_option_values: false}
      this.loadingRule = false
      this.showRuleEditor = true
    },
    openEditRule (rule) {
      this.categoryTaxResult = ''
      this.ruleForm = emptyRule()
      this.taxCategoryTool = {category_ids: [], tax_rule_ids: [rule.id], include_option_values: false}
      this.loadingRule = true
      this.showRuleEditor = true
      this.apiRequest('/taxes-v2/rules/' + rule.id, 'GET', this.requestData(), r => {
        this.loadingRule = false
        if (!r.status) { this.notify(this.responseMessage(r, 'Taxa nu a putut fi încărcată.'), 'error'); this.closeRuleEditor(); return }
        this.ruleForm = Object.assign(emptyRule(), JSON.parse(JSON.stringify(r.data || {})))
        this.mergeDeliveryRanges(this.ruleForm.delivery_ranges || [])
        this.handleRuleTypeChange()
      })
    },
    closeRuleEditor () {
      if (this.applyingCategoryTaxes) return
      this.categoryTaxResult = ''
      this.showRuleEditor = false
      this.loadingRule = false
      this.ruleForm = emptyRule()
      this.taxCategoryTool = {category_ids: [], tax_rule_ids: [], include_option_values: false}
      this.clearRuleRouteQuery()
    },
    handleRuleTypeChange () {
      if (this.ruleForm.applies_to === 'delivery') {
        this.ruleForm.calculation_type = 'fixed'
        this.ruleForm.method_ids = [3]
      }
      if (!Array.isArray(this.ruleForm.delivery_cost_ranges)) this.$set(this.ruleForm, 'delivery_cost_ranges', [])
    },
    addDeliveryCostRange () {
      this.ruleForm.delivery_cost_ranges.push({distance_in_km: '', shipping_cost: '', pos_id: '', min_order_value: 0, extra_delivery_time: 0})
    },
    removeDeliveryCostRange (index) { this.ruleForm.delivery_cost_ranges.splice(index, 1) },
    openRuleFromRoute () {
      const query = this.$route.query || {}
      if (query.taxRuleId) {
        this.activeTab = 'rules'
        this.openEditRule({id: query.taxRuleId})
        return
      }
      if (query.newTax === 'delivery') {
        this.activeTab = 'rules'
        const deliveryRangeId = query.deliveryRangeId ? Number(query.deliveryRangeId) : null
        const locationId = query.locationId ? Number(query.locationId) : null
        this.openCreateRule({
          applies_to: 'delivery',
          calculation_type: 'fixed',
          method_ids: [3],
          delivery_range_ids: deliveryRangeId ? [deliveryRangeId] : [],
          location_ids: locationId ? [locationId] : []
        })
      }
    },
    clearRuleRouteQuery () {
      const query = Object.assign({}, this.$route.query || {})
      if (!query.taxRuleId && !query.newTax && !query.deliveryRangeId && !query.locationId) return
      delete query.taxRuleId
      delete query.newTax
      delete query.deliveryRangeId
      delete query.locationId
      this.$router.replace({path: this.$route.path, query})
    },
    toggleRule (rule, active) {
      const payload = Object.assign({}, JSON.parse(JSON.stringify(rule)), {is_active: active})
      this.apiRequest('/taxes-v2/rules/' + rule.id, 'PUT', this.requestData(payload), r => { if (r.status) { this.loadRules(); this.notify(active ? 'Taxa a fost activată.' : 'Taxa a fost dezactivată.') } else this.notify(this.responseMessage(r, 'Taxa nu a putut fi actualizată.'), 'error') })
    },
    deleteRule (rule) { this.apiRequest('/taxes-v2/rules/' + rule.id, 'DELETE', this.requestData(), r => { if (r.status) { this.loadRules(); this.notify('Taxa a fost dezactivată și arhivată.') } else this.notify(this.responseMessage(r, 'Taxa nu a putut fi ștearsă.'), 'error') }) }
  }
}
</script>

<style scoped>
.taxes-v2 {
  box-sizing: border-box;
  min-width: 0;
  overflow-x: hidden;
  padding-bottom: 30px;
  width: 100%;
}

.taxes-v2 *,
.taxes-v2 *::before,
.taxes-v2 *::after {
  box-sizing: border-box;
}

.tax-card {
  margin: 15px 15px 0;
  overflow: visible;
}

.tax-card .card-content {
  padding: 24px 26px;
}

.tax-engine-card {
  margin-top: 15px;
}

.tax-engine-content,
.tax-card-header,
.tax-card-footer {
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;
}

.tax-card-header {
  flex-wrap: wrap;
  margin-bottom: 22px;
}

.tax-card-title {
  color: #153474;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.35;
  margin: 0;
}

.tax-help {
  color: #7388b5;
  font-size: 14px;
  line-height: 1.45;
  margin: 5px 0 0;
}

.tax-list-header {
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-bottom: 20px;
}

.tax-list-header .btn.add {
  flex: 0 0 auto;
  margin: 0;
  width: auto;
}

.tax-rate-input {
  min-width: 160px;
  position: relative;
}

.tax-rate-input .form-control {
  padding-right: 38px;
}

.tax-rate-input > span {
  color: #7388b5;
  position: absolute;
  right: 15px;
  top: 13px;
}

.tax-primary-action {
  border: 0;
  border-radius: 24px;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  min-height: 44px;
  padding: 11px 24px;
  white-space: nowrap;
}

.tax-primary-action,
.tax-primary-action:focus,
.tax-primary-action:hover {
  background: #dff7f2;
  color: #00ad82;
}

.tax-primary-action[disabled] {
  opacity: .55;
}

.tax-form-grid {
  display: grid;
  gap: 18px;
  min-width: 0;
}

.tax-form-grid .form-group {
  margin: 0;
  min-width: 0;
}

.tax-form-grid .form-group > label {
  color: #153474;
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}

.tax-form-grid .form-group > .tax-switch {
  display: inline-flex;
  margin-bottom: 0;
}

.tax-category-vat-grid {
  align-items: end;
  grid-template-columns: minmax(280px, 2fr) minmax(210px, 1fr) auto;
}

.tax-profile-grid {
  grid-template-columns: repeat(3, minmax(180px, 1fr));
}

.tax-rule-main-grid {
  grid-template-columns: repeat(5, minmax(150px, 1fr));
}

.tax-scope-grid {
  grid-template-columns: repeat(4, minmax(180px, 1fr));
}

.tax-vat-details-grid {
  align-items: end;
  grid-template-columns: minmax(220px, 320px) auto;
}

.tax-rule-category-grid {
  align-items: start;
  gap: 24px;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.tax-assignment-tool {
  border: 1px solid #ded6f5;
  border-left: 3px solid #8d73df;
  background: #fcfbff;
}

.tax-tool-badge {
  color: #6748d7;
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 10px;
}

.tax-tool-badge i,
.tax-apply-action i {
  margin-right: 7px;
}

.tax-tool-explanation {
  align-items: baseline;
  background: #f0ecfa;
  border-radius: 8px;
  color: #42306b;
  display: flex;
  font-size: 13px;
  gap: 10px;
  line-height: 1.6;
  margin-bottom: 22px;
  padding: 12px 16px;
}

.tax-tool-explanation strong {
  color: inherit;
}

.tax-rule-category-grid .form-group > .tax-checkbox {
  display: flex;
  font-weight: 400;
}

.tax-rule-category-grid .form-group > .tax-options-checkbox {
  align-items: center;
  background: #fff;
  border: 1px solid #e1e6f2;
  border-radius: 6px;
  font-weight: 500;
  min-height: 46px;
  margin-bottom: 0;
  padding: 10px 14px;
}

.tax-options-checkbox input {
  accent-color: #6748d7;
  height: 16px;
  margin: 0;
  width: 16px;
}

.tax-option-help,
.tax-option-note {
  color: #7388b5;
  font-size: 12px;
  line-height: 1.5;
  margin: 8px 0 0;
}

.tax-option-note {
  color: #77511c;
}

.tax-tool-pending {
  color: #975400;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 6px;
}

.tax-assignment-tool .tax-apply-action,
.tax-assignment-tool .tax-apply-action:hover,
.tax-assignment-tool .tax-apply-action:focus {
  background: #6748d7;
  color: #fff;
  flex-shrink: 0;
}

.tax-assignment-tool .tax-apply-action:disabled,
.tax-assignment-tool .tax-apply-action:disabled:hover,
.tax-assignment-tool .tax-apply-action:disabled:focus {
  background: #e8e2f5;
  color: #716386;
  cursor: not-allowed;
  opacity: 1;
}

.tax-tool-result {
  background: #e1f6ec;
  border-radius: 8px;
  color: #167150;
  line-height: 1.5;
  margin: 18px 0 0;
  padding: 14px 18px;
}

.tax-grid-wide {
  grid-column: span 2;
}

.tax-form-action {
  align-items: flex-end;
  display: flex;
  padding-bottom: 20px;
}

.tax-selected-entity {
  align-items: flex-start;
  background: #f1f4fc;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 46px;
  padding: 7px 14px;
}

.tax-selected-entity span {
  color: #8b9bc1;
  font-size: 11px;
}

.tax-selected-entity strong {
  color: #153474;
  font-size: 16px;
}

.tax-select {
  width: 100%;
}

.tax-edit-action {
  cursor: pointer;
  display: inline-block;
}

.tax-field-hint {
  color: #8b9bc1;
  display: block;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 6px;
}

.tax-card-footer {
  border-top: 1px solid #e7ebf5;
  flex-wrap: wrap;
  margin-top: 22px;
  padding-top: 20px;
}

.tax-active-field {
  align-self: stretch;
}

.tax-status-switch {
  background: #fff;
  border: 1px solid #e1e6f2;
  border-radius: 6px;
  min-height: 46px;
  padding: 10px 14px;
}

.tax-tool-options {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 22px;
  justify-content: center;
  min-width: 0;
}

.tax-checkbox {
  align-items: flex-start;
  color: #153474;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  gap: 9px;
  line-height: 1.45;
}

.tax-checkbox input {
  flex: 0 0 auto;
  margin-top: 3px;
}

.tax-switch {
  align-items: center;
  color: #153474;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 14px;
  gap: 9px;
  margin: 0;
}

.tax-switch input {
  height: 1px;
  opacity: 0;
  position: absolute;
  width: 1px;
}

.tax-switch-track {
  background: #cbd4eb;
  border-radius: 20px;
  display: inline-block;
  flex: 0 0 auto;
  height: 24px;
  padding: 3px;
  transition: background .2s ease;
  width: 44px;
}

.tax-switch-thumb {
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(21, 52, 116, .3);
  display: block;
  height: 18px;
  transition: transform .2s ease;
  width: 18px;
}

.tax-switch input:checked + .tax-switch-track {
  background: #6748d7;
}

.tax-switch input:checked + .tax-switch-track .tax-switch-thumb {
  transform: translateX(20px);
}

.tax-switch input:focus + .tax-switch-track {
  box-shadow: 0 0 0 3px rgba(103, 72, 215, .18);
}

.tax-switch-small {
  font-size: 13px;
}

.tax-switch-small .tax-switch-track {
  height: 20px;
  width: 36px;
}

.tax-switch-small .tax-switch-thumb {
  height: 14px;
  width: 14px;
}

.tax-switch-small input:checked + .tax-switch-track .tax-switch-thumb {
  transform: translateX(16px);
}

.tax-rules-table {
  min-width: 1040px;
}

.tax-delivery-warning {
  background: #fff1f1;
  border: 1px solid #f2a7a7;
  border-radius: 6px;
  color: #c62828;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 20px;
  padding: 15px 18px;
}

.tax-delivery-warning i {
  margin-right: 9px;
}

.tax-delivery-warning strong {
  margin-right: 5px;
}

.tax-delivery-range {
  background: #f8f9fd;
  border: 1px solid #e2e7f3;
  border-radius: 8px;
  margin-top: 15px;
  padding: 18px;
}

.tax-range-heading {
  align-items: center;
  color: #153474;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.tax-range-heading .btn.delete {
  margin: 0;
}

.tax-delivery-range-grid {
  grid-template-columns: repeat(5, minmax(150px, 1fr));
}

.tax-range-empty {
  border: 1px dashed #d7deef;
  border-radius: 6px;
}

.tax-rate-value {
  color: #153474 !important;
  font-size: 16px;
  font-weight: 600;
}

.tax-actions-cell {
  white-space: nowrap;
}

.tax-actions-cell .btn.delete.disabled {
  opacity: .45;
  pointer-events: none;
}

.tax-empty {
  color: #8b9bc1 !important;
  padding: 28px 15px !important;
  text-align: center;
}

.tax-page-loading {
  min-height: 180px;
  position: relative;
}

.tax-page-enter-active,
.tax-page-leave-active {
  transition: opacity .18s ease, transform .18s ease;
}

.tax-page-enter,
.tax-page-leave-to {
  opacity: 0;
  transform: translateX(10px);
}

@media (max-width: 1400px) {
  .tax-profile-grid,
  .tax-rule-main-grid,
  .tax-delivery-range-grid {
    grid-template-columns: repeat(3, minmax(180px, 1fr));
  }

  .tax-tool-options {
    grid-column: 1 / -1;
  }
}

@media (max-width: 1050px) {
  .tax-category-vat-grid,
  .tax-profile-grid,
  .tax-rule-main-grid,
  .tax-scope-grid,
  .tax-rule-category-grid,
  .tax-delivery-range-grid {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }

  .tax-form-action {
    padding-bottom: 0;
  }
}

@media (max-width: 767px) {
  .tax-card {
    margin-left: 10px;
    margin-right: 10px;
  }

  .tax-card .card-content {
    padding: 20px 16px;
  }

  .tax-engine-content,
  .tax-card-header,
  .tax-list-header,
  .tax-card-footer {
    align-items: flex-start;
    flex-direction: column;
  }

  .tax-rate-input {
    flex: 1 1 auto;
  }

  .tax-list-header .btn.add {
    width: 100%;
  }

  .tax-category-vat-grid,
  .tax-profile-grid,
  .tax-rule-main-grid,
  .tax-scope-grid,
  .tax-vat-details-grid,
  .tax-rule-category-grid,
  .tax-delivery-range-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .tax-grid-wide,
  .tax-tool-options {
    grid-column: auto;
  }

  .tax-form-action,
  .tax-form-action .btn,
  .tax-card-footer .btn,
  .tax-tool-options .btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/TaxesV2.vue